import { Link } from "gatsby"
import * as React from "react"
import { Helmet } from "react-helmet"
import Layout from "../layouts/RootLayout"

function Blog({ pageContext }) {
  // Get articles from pageContext (passed from gatsby-node.js)
  const articles = pageContext?.articles || []

  return (
    <Layout>
      <Helmet>
        <title>Jeffpiscine.fr - Blog</title>
        <meta
          name="description"
          content="Découvrez nos conseils d'experts pour l'entretien de votre piscine et spa. Filtration, traitement de l'eau, rénovation et plus encore."
        />
        <meta property="og:title" content="Blog Piscine & Spa - Jeffpiscine" />
        <meta
          property="og:description"
          content="Conseils d'experts pour l'entretien de votre piscine et spa en Meuse."
        />
        <link rel="canonical" href="https://www.jeffpiscine.fr/blog" />
      </Helmet>
      <div className="bg-secondary">
        <div className="bg-dark pt-4 pb-5">
          <div className="container pt-2 pb-3 pt-lg-3 pb-lg-4">
            <div className="d-lg-flex justify-content-between pb-3">
              <div className="order-lg-2 mb-3 mb-lg-0 pt-lg-2">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb breadcrumb-light flex-lg-nowrap justify-content-center justify-content-lg-start">
                    <li className="breadcrumb-item">
                      <a className="text-nowrap" href="/">
                        <i className="czi-home"></i>Accueil
                      </a>
                    </li>
                    <li className="breadcrumb-item text-nowrap">
                      <a href="/blog">Blog</a>
                    </li>
                    <li
                      className="breadcrumb-item text-nowrap active"
                      aria-current="page"
                    >
                      Tous les articles
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="order-lg-1 pr-lg-4 text-center text-lg-left">
                <h1 className="h3 text-light mb-0">Nos conseils</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5 pb-5">
          <div className="row">
            {articles.map((article, index) => (
              <div className="col-lg-4 col-md-6 mb-4" key={index}>
                <article className="card h-100 border-0 shadow-sm">
                  {article.content.data.image && (
                    <Link to={"/blog/" + article.content.data.handle}>
                      <img
                        src={article.content.data.image}
                        alt={article.content.data.title}
                        className="card-img-top"
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                    </Link>
                  )}
                  <div className="card-body">
                    <h2 className="h5 card-title blog-entry-title">
                      <Link to={"/blog/" + article.content.data.handle}>
                        {article.content.data.title}
                      </Link>
                    </h2>
                    <p className="card-text text-muted" style={{ fontSize: "0.9rem" }}>
                      {article.content.data.description?.substring(0, 150)}
                      {article.content.data.description?.length > 150 ? "..." : ""}
                    </p>
                    <Link
                      to={"/blog/" + article.content.data.handle}
                      className="btn btn-outline-primary btn-sm"
                    >
                      Lire la suite
                    </Link>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Blog
